import React from 'react';
import CloseButtonPromotion from './closeButtonPromotion/CloseButtonPromotion';
import LinkButtonPromotion from './linkButtonPromotion/LinkButtonPromotion';
import classes from './ContentPromotionPopup.module.css';

const PromotionButtons = ({ primaryButton, secondaryButton, closeText, onClose }) => {
    
    const slots = { left: null, right: null };

    if (primaryButton?.enabled) {
        slots[primaryButton.side] = (
            <CloseButtonPromotion
                button={primaryButton}
                text={primaryButton.text || closeText}
                onClose={onClose}
            />
        );
    }

    if (secondaryButton?.enabled) {
        slots[secondaryButton.side] = (
            <LinkButtonPromotion
                button={secondaryButton}
                text={secondaryButton.text}
                onClose={onClose}
            />
        );
    }

    return (
        <div className={classes.Buttons} dir="ltr">
            <div className={classes.ButtonSlot}>{slots.left}</div>
            <div className={classes.ButtonSlot}>{slots.right}</div>
        </div>
    );
};

export default PromotionButtons;
